import type { IconName } from '@cencosud-cencommerce/paris-uikit';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';
import type ColorKey from '@cencosud-cencommerce/paris-uikit/dist/utils/types/Colors.type';

import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';

interface ModalRemoveCouponProps {
  couponName: string;
  isOpen: boolean;
  onClose: () => void;
  removeCoupon: () => void;
}

interface Icon {
  name: IconName;
  fill?: ColorKey;
}

const WARNING_ICON: Icon = {
  name: 'warning-circle',
  fill: 'error-500'
};

const LABEL_HEADER_TITLE = '¿Quieres eliminar tu cupón?';
const LABEL_BODY_TEXT = 'Se eliminará el descuento aplicado';
const LABEL_BUTTON_REMOVE = 'Eliminar';
const LABEL_BUTTON_CANCEL = 'Cancelar';

const ModalRemoveCoupon = (props: ModalRemoveCouponProps) => {
  const { removeCoupon, onClose, isOpen, couponName } = props;

  const { deleteCouponGtm, cancelDeleteCouponGtm } = useGtmBillingProduct();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader
        onClose={onClose}
        icon={WARNING_ICON}
        title={LABEL_HEADER_TITLE}
      />

      <ModalBody>
        <Text variant="body1" className="co-text-[16px]">
          {LABEL_BODY_TEXT}
        </Text>
      </ModalBody>

      <ModalFooter
        buttonsAlign="vertical"
        primaryButton={{
          label: LABEL_BUTTON_REMOVE,
          className: 'co-w-full co-bg-error-500 hover:co-bg-error-600',
          onClick: () => {
            deleteCouponGtm(couponName);
            removeCoupon();
            onClose();
          }
        }}
        secondaryButton={{
          label: LABEL_BUTTON_CANCEL,
          onClick: () => {
            cancelDeleteCouponGtm(couponName);
            onClose();
          }
        }}
      ></ModalFooter>
    </Modal>
  );
};

ModalRemoveCoupon.displayName = 'ModalRemoveCoupon';

export default ModalRemoveCoupon;
